/**
 * CompromissosBlock — agenda do lead.
 *
 * Lista compromissos [data/hora · tipo · local · responsavel] com remarcar
 * (CRM-25: abre o dialog em modo edicao — antes so dava excluindo e
 * recriando), marcar realizado e excluir + botao "Novo compromisso" (dialog
 * controlado pelo pai). Realizados descem para o fim com badge.
 */
import React, { useMemo } from "react";
import { FiCalendar, FiCheck, FiEdit2, FiPlus, FiTrash2 } from "react-icons/fi";

import Block from "../../../components/Block";
import { TIPO_COMPROMISSO_LABEL } from "../../../services/crm";
import { EmptyMsg } from "../../Orcamentos/styles";

import { LinhaInfo, LinhaItem, LinhaSub, LinhaTitulo, MiniButton } from "./styles";

function fmtDataHora(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
}

function CompromissosBlock({
  compromissos,
  onNovo,
  onEditar,
  onRealizar,
  onExcluir,
  podeEditar,
  collapsible,
  defaultCollapsed,
}) {
  const lista = useMemo(() => {
    const arr = Array.isArray(compromissos) ? [...compromissos] : [];
    arr.sort((a, b) => {
      if (Boolean(a.realizado) !== Boolean(b.realizado)) {
        return a.realizado ? 1 : -1;
      }
      return new Date(a.data_hora || 0) - new Date(b.data_hora || 0);
    });
    return arr;
  }, [compromissos]);

  return (
    <Block
      title={`Compromissos (${lista.length})`}
      collapsible={collapsible}
      defaultCollapsed={defaultCollapsed}
      actions={
        podeEditar ? (
          <button
            type="button"
            className="btn btn--secondary btn--sm"
            onClick={onNovo}
          >
            <FiPlus size={13} aria-hidden="true" /> Novo
          </button>
        ) : null
      }
    >
      {lista.length === 0 ? (
        <EmptyMsg style={{ padding: 8 }}>
          Nenhum compromisso agendado.
        </EmptyMsg>
      ) : (
        lista.map((c) => (
          <LinhaItem key={c.id}>
            <LinhaInfo>
              <LinhaTitulo>
                <FiCalendar
                  size={12}
                  style={{ verticalAlign: "middle", marginRight: 4 }}
                  aria-hidden="true"
                />
                {c.titulo}
                {c.realizado && (
                  <span className="badge success no-dot" style={{ marginLeft: 6 }}>
                    Realizado
                  </span>
                )}
              </LinhaTitulo>
              <LinhaSub>
                {fmtDataHora(c.data_hora)} ·{" "}
                {c.tipo_display || TIPO_COMPROMISSO_LABEL[c.tipo] || c.tipo}
                {c.local ? ` · ${c.local}` : ""}
                {c.responsavel_nome ? ` · ${c.responsavel_nome}` : ""}
              </LinhaSub>
            </LinhaInfo>
            {podeEditar && (
              <div style={{ display: "flex", gap: 4 }}>
                {!c.realizado && onEditar && (
                  <MiniButton
                    type="button"
                    onClick={() => onEditar(c)}
                    title="Remarcar compromisso"
                    aria-label={`Remarcar ${c.titulo}`}
                  >
                    <FiEdit2 size={12} aria-hidden="true" />
                  </MiniButton>
                )}
                <MiniButton
                  type="button"
                  onClick={() => onRealizar(c.id, !c.realizado)}
                  title={c.realizado ? "Marcar como pendente" : "Marcar realizado"}
                >
                  <FiCheck size={13} aria-hidden="true" />
                </MiniButton>
                <MiniButton
                  type="button"
                  $tone="danger"
                  onClick={() => onExcluir(c.id)}
                  title="Excluir compromisso"
                >
                  <FiTrash2 size={12} aria-hidden="true" />
                </MiniButton>
              </div>
            )}
          </LinhaItem>
        ))
      )}
    </Block>
  );
}

export default CompromissosBlock;
